import type { VariantType } from '../../../types/variant';
import styles from './ProgressAnime.module.scss';

export interface ProgressAnimeProps {
  variant?: VariantType;
}

/**
 * goodsmilekujiのみデザインが異なる
 */

// biome-ignore lint/correctness/noUnusedVariables: <explanation>
function ProgressAnime({ variant = 'default' }: ProgressAnimeProps) {
  const componentStyles = styles;

  return (
    <div className={componentStyles.componentStyle}>
      <div className={componentStyles.loader} />
    </div>
  );
}

export default ProgressAnime;
